module.exports = __webpack_public_path__ + "img/5.5e5adda3.jpeg";